import { useCallback, useEffect, useRef, useState } from "react";
import MobileHeader from "../MobileHeader";
import Header from "../header";
import { useMediaQuery } from "react-responsive";
import Footer from "../footer";
import axios from "axios";
import useChat from "../../hooks/useChat";
import useGroupChat from "../../hooks/useGroupChat";
import useMessageList from "../../hooks/useMessageList";
import ClipLoader from "react-spinners/ClipLoader";
import admin from "../../assets/admin.png";
import DropdownActions from "../DropdownActions";
import { toast } from "react-toastify";
import { ThreeDot } from "react-loading-indicators";
import { MessageCircle} from "lucide-react";
import { Users } from "lucide-react";
import CollapsibleSection from "./CollapsibleSection";
import ChatContainer from "./ChatContainer";
import ChatSidebar from "./ChatSidebar";
import CreateGroupModal from "./CreateGroupModal";
import ChatInput from "./ChatInput";
import AddMembersModal from "./AddMembersModal";
import EditGroupModal from "./EditGroupModal";
import ChatHeader from "./ChatHeader";
import { useLocation } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Chat = () => {
  const token = localStorage.getItem("access_token");
  const location = useLocation()
  const chatId = location.state?.chatId
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [connectedUsers, setConnectedUsers] = useState([]);
  const [activeUser, setActiveUser] = useState(null);
  const [showDeleteGroupModal, setShowDeleteGroupModal] = useState(false);
  const [loadingGroupDelete, setLoadingGroupDelete] = useState(false);
  const [userRole, setUserRole] = useState(null);
  // const { messages, sendMessage, setMessages } = useChat(activeUser?.id);
    // console.log("The chat id is:",chatId)
  const {
    messages: userMessages,
    sendMessage: sendUserMessage,
    setMessages: setUserMessages,
    sendFile: sendUserFile,
  } = useChat(activeUser?.is_group ? null :chatId ? chatId : activeUser?.id);
  const {
    messages: groupMessages,
    sendMessage: sendGroupMessage,
    setMessages: setGroupMessages,
    sendFile: sendGroupFile, 
  } = useGroupChat(activeUser?.is_group ? activeUser?.id : null);
  const sendFile = activeUser?.is_group ? sendGroupFile : sendUserFile;

  const messages = activeUser?.is_group ? groupMessages : userMessages;
  const sendMessage = activeUser?.is_group ? sendGroupMessage : sendUserMessage;
  const setMessages = activeUser?.is_group ? setGroupMessages : setUserMessages;
  const [editingMessageId, setEditingMessageId] = useState(null);
  const [editText, setEditText] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [showCreateGroup, setShowCreateGroup] = useState(false);
  const [newGroupName, setNewGroupName] = useState("");
  const [newGroupImage, setNewGroupImage] = useState(null);
  const [showEditGroup, setShowEditGroup] = useState(false);
  const [groups, setGroups] = useState([]);
  const [showAddMembers, setShowAddMembers] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [membersToAdd, setMembersToAdd] = useState([]);
  const [groupMembers, setGroupMembers] = useState([]);
  const [showMembers, setShowMembers] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [showExitGroupModal, setShowExitGroupModal] = useState(false);
  const [open, setOpen] = useState(false);
  const membersRef = useRef(null);
 const [showFooter, setShowFooter] = useState(false);


  const [selectedUsers, setSelectedUsers] = useState([]);

  const isActiveUserConnected = activeUser?.is_group
    ? true
    : connectedUsers.some((c) => c.user_profile?.id === activeUser?.id);

  const {
    conversations,
    unreadCount,
    markConversationRead,
    unreadMap,
    setConversations,
  } = useMessageList();

  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/user/chat/connected-users-list/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      })
      .then((res) => {
        setConnectedUsers(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch users", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const fetchCurrentUser = useCallback(async () => {
    try {
      const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
        headers: { Authorization: `Bearer ${token}` ,  "x-api-key": process.env.REACT_APP_X_API_KEY,},
      });
      const data = await res.json();
      if (res.ok) {
        setCurrentUserId(data.data?.id);
        localStorage.setItem("user_id", data.data?.user);
      } else {
        console.error("");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error getting user profile.");
    }
  }, [BASE_URL, token]);

  useEffect(() => {
    fetchCurrentUser();
  }, [fetchCurrentUser]);

  const fetchGroups = async () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/user/chat/create-group/`, {
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
      })
      .then((res) => setGroups(res.data))
      .catch((err) => console.error("Failed to fetch groups", err))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    fetchGroups();
  }, []);

  const confirmDeleteGroup = async () => {
    try {
      setLoadingGroupDelete(true);
      await axios.delete(`${BASE_URL}/user/chat/delete-group/`, {
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
        data: { group_id: activeUser.id },
      });

      toast.success("Group deleted successfully");
      setShowDeleteGroupModal(false);
      setActiveUser(null);

      fetchGroups();
    } catch (error) {
      console.error("Error deleting group:", error);
      toast.error("Failed to delete group");
    } finally {
      setLoadingGroupDelete(false);
    }
  };

  const handleSendMessage = (e) => {
    e.preventDefault();
    // console.log("The e is:",e)
    const input = e.target.elements.messageInput;
    const content = input.value.trim();
    if (!content) return;
    sendMessage(content);
    input.value = "";
  };

  const inboxUserIds = new Set(conversations.map((c) => c.user_profile?.id));
  const filteredConnectedUsers = connectedUsers.filter(
    (c) => !inboxUserIds.has(c.user_profile?.id)
  );

  const usersNotInInbox = filteredConnectedUsers.filter(
    (conn) =>
      !conversations.some(
        (conv) => conv.user_profile?.id === conn.user_profile?.id
      )
  );

  const handleSelectUser = (user) => {
    setActiveUser(user);
    markConversationRead(user.id);
  };

  const handleEditGroupSubmit = async () => {
    if (!newGroupName.trim()) {
      toast.error("Please provide a group name");
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("id", activeUser.id);
      formData.append("name", newGroupName);

      if (newGroupImage) {
        formData.append("profile_image", newGroupImage);
      }
      const res = await axios.patch(
        `${BASE_URL}/user/chat/create-group/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        }
      );

      if (res.status === 200 || res.status === 201) {
        toast.success("Group updated successfully!");
        setShowEditGroup(false);
        setNewGroupName("");
        setNewGroupImage(null);
        setGroups((prev) =>
          prev.map((group) =>
            group.id === activeUser.id ? res.data.data : group
          )
        );
        setActiveUser((prev) => ({
          ...prev,
          name: res.data.data.name,
          profile_image: res.data.data.profile_image,
        }));
      }
    } catch (err) {
      console.error("Failed to update group:", err);
      toast.error("Failed to update group");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!activeUser) {
      if (conversations.length > 0) {
        const firstUser = conversations[0].user_profile;
        setActiveUser(firstUser);
        markConversationRead(firstUser.id);
      } else if (connectedUsers.length > 0) {
        setActiveUser(connectedUsers[0].user_profile);
      }
    }
  }, [conversations, connectedUsers, activeUser, markConversationRead]);

  const handleDeleteMessage = async (msg) => {
    try {
      if (activeUser.is_group) {
        const formData = new FormData();
        formData.append("message_id", msg.id);
        formData.append("group_id", activeUser.id);
        formData.append("message", msg.message);

        await axios.delete(`${BASE_URL}/user/chat/group-message-list/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
          data: formData,
        });
      } else {
        await axios.delete(`${BASE_URL}/user/chat/messages-by-profileID/`, {
          headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
          params: { friend_id: activeUser.id },
          data: { message_id: msg.id },
        });
      }

      setMessages((prev) => prev.filter((m) => m.id !== msg.id));
      toast.success("Message deleted successfully!");
    } catch (err) {
      console.error("Error deleting message:", err);
      toast.error("Failed to delete message");
    }
  };

  const saveEdit = async (msg) => {
    if (!editText.trim()) return;

    try {
      if (activeUser.is_group) {
        const formData = new FormData();
        formData.append("message_id", msg.id);
        formData.append("group_id", activeUser.id);
        formData.append("message", editText);

        const response = await axios.put(
          `${BASE_URL}/user/chat/group-message-list/`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
              "x-api-key": process.env.REACT_APP_X_API_KEY
            },
          }
        );

        if (response.status === 200) {
          setMessages((prev) =>
            prev.map((m) => (m.id === msg.id ? { ...m, message: editText } : m))
          );
          setEditingMessageId(null);
          setEditText("");
          toast.success("Message updated successfully!");
        }
      } else {
        const response = await axios.put(
          `${BASE_URL}/user/chat/messages-by-profileID/`,
          { message_id: msg.id, message: editText },
          {
            headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
            params: { friend_id: activeUser.id },
          }
        );

        if (response.status === 200) {
          setMessages((prev) =>
            prev.map((m) => (m.id === msg.id ? { ...m, message: editText } : m))
          );
          setEditingMessageId(null);
          setEditText("");
          toast.success("Message updated successfully!");
        }
      }
    } catch (err) {
      console.error("Failed to edit message:", err);
      if (
        err.response &&
        err.response.data &&
        err.response.data.error ===
        "Message can only be updated within 1 hour of creation."
      ) {
        toast.error("Message can only be edited within 1 hour of sending.");
      } else {
        toast.error("Something went wrong while editing the message.");
      }
    }
  };

  const handleDeleteChatHistory = () => {
    if (!activeUser) return;
    setShowDeleteModal(true);
  };


  

  const confirmDeleteChatHistory = async () => {
    if (!activeUser) return;

    try {
      setLoadingDelete(true);

      if (activeUser.is_group) {
        const formData = new FormData();
        formData.append("group_id", activeUser.id);

        await axios.delete(`${BASE_URL}/user/chat/delete-group-chat-history/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
          data: formData,
        });
      } else {
        await axios.post(
          `${BASE_URL}/user/chat/delete-chat-history/`,
          { friend_id: activeUser.id },
          { headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY } }
        );
      }

      setMessages([]);
      setConversations((prev) =>
        prev.filter((conv) => conv.user_profile.id !== activeUser.id)
      );

      toast.success("Chat history deleted successfully!");
      setShowDeleteModal(false);
    } catch (err) {
      console.error("Error deleting chat history:", err);
      toast.error("Failed to delete chat history.");
    } finally {
      setLoadingDelete(false);
    }
  };


  const handleCreateGroupSubmit = async () => {
    if (!newGroupName.trim()) {
      toast.error("Please provide a group name");
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("name", newGroupName);
      if (newGroupImage) {
        formData.append("profile_image", newGroupImage);
      }

      const res = await axios.post(
        `${BASE_URL}/user/chat/create-group/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        }
      );

      if (res.status === 200 || res.status === 201) {
        toast.success("Group created successfully!");
        setShowCreateGroup(false);
        setNewGroupName("");
        setNewGroupImage(null);
        setGroups((prev) => [...prev, res.data.data]);
      }
    } catch (err) {
      console.error("Failed to create group:", err);
      toast.error("Failed to create group");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenAddMembers = (group) => {
    setSelectedGroup(group);
    setShowAddMembers(true);
  };

  const toggleMemberSelection = (userId) => {
    setMembersToAdd((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  const fetchGroupMembers = async () => {
    if (activeUser?.is_group) {
      try {
        const res = await axios.get(
          `${BASE_URL}/user/chat/group-member-list/?group_id=${activeUser.id}`,
          { headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY } }
        );
        setGroupMembers(res.data.members);
        const currentMember = res.data.members.find(
          (m) => m.user.id === currentUserId
        );

        setUserRole(currentMember?.role || null);
      } catch (err) {
        console.error("Failed to fetch group members:", err);
        toast.error("Failed to load group members");
      }
    } else {
      setGroupMembers([]);
      setUserRole(null);
    }
  };

  useEffect(() => {
    fetchGroupMembers();
  }, [activeUser]);

  const handleAddMembersSubmit = async () => {
    if (!selectedGroup || membersToAdd.length === 0) {
      toast.error("Select members to add");
      return;
    }

    try {
      for (let memberId of membersToAdd) {
        const formData = new FormData();
        formData.append("group_id", selectedGroup.id);
        formData.append("member_id", memberId);
        formData.append("is_admin", "False"); // or "True" if needed

        await axios.post(`${BASE_URL}/user/chat/add-group-member/`, formData, {
          headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
        });
      }
      toast.success("Members added successfully!");
      setShowAddMembers(false);
      setMembersToAdd([]);
      fetchGroupMembers();
    } catch (err) {
      console.error("Failed to add members:", err);
      toast.error("Failed to add members");
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    function handleClickOutside(e) {
      if (membersRef.current && !membersRef.current.contains(e.target)) {
        setShowMembers(false);
      }
    }
    if (showMembers) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMembers]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleExitGroup = async () => {
    if (!activeUser || !activeUser.is_group) return;

    try {
      const formData = new FormData();
      formData.append("group_id", activeUser.id);

      const response = await axios.post(
        `${BASE_URL}/user/chat/exit-from-group/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        }
      );

      if (response.status === 200) {
        toast.success(`You have exited ${activeUser.name}`);
        setActiveUser(null);
        setGroups((prev) => prev.filter((g) => g.id !== activeUser.id));
      }
    } catch (err) {
      toast.error("Failed to exit group:", err);
    }
  };

  const handleRemoveMember = async (memberId) => {
    if (!activeUser?.id) return;

    try {
      const formData = new FormData();
      formData.append("group_id", activeUser.id);
      formData.append("member_id", memberId);
      const res = await axios.delete(
        `${BASE_URL}/user/chat/add-group-member/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
          data: formData,
        }
      );
      if (res.status === 200) {
        toast.success("Member removed successfully!");
        setGroupMembers((prev) => prev.filter((m) => m.user.id !== memberId));
      }
    } catch (err) {
      console.error("Failed to remove member:", err);
      toast.error("Failed to remove member");
    }
  };

  useEffect(()=>{
    const fetchProfileById=async()=>{
         try {
           const res=await axios.get(`${BASE_URL}/user/profile/all-profiles?id=${chatId}`,{
            headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          }
           })
           handleSelectUser(res?.data?.data)
         } catch (error) {
            console.log(error)
         }
    }
fetchProfileById() 
  },[chatId])
  
  return (

   <div className="flex flex-col h-screen">
  {/* Header */}
  {isMobile ? (
    <MobileHeader hideHome hideHamburger hideFilter />
  ) : (
    <Header hideHome hideFilter className="h-16" />
  )}

  {/* Chat area */}
  <main  onScroll={(e) => {
      const scrollTop = e.currentTarget.scrollTop;
      setShowFooter(scrollTop > 50); // show footer only when user scrolls
    }} className="flex-1  flex overflow-hidden">
       {loading ? (
      <div className="absolute inset-0 flex justify-center items-center bg-white z-50">
    <ClipLoader color="#0f6abf" size={40} />
  </div>

    ) : (
      <>
{/* Sidebar */}
    <ChatSidebar
      setShowCreateGroup={setShowCreateGroup}
      Users={Users}
      CollapsibleSection={CollapsibleSection}
      groups={groups}
      activeUser={activeUser}
      setActiveUser={setActiveUser}
      admin={admin}
      conversations={conversations}
      unreadMap={unreadMap}
      handleSelectUser={handleSelectUser}
      usersNotInInbox={usersNotInInbox}
      filteredConnectedUsers={filteredConnectedUsers}
    />
      {/* Main Chat */}
    <div className="flex-1 flex flex-col bg-white">
      {activeUser ? (
        <>
          <ChatHeader
            activeUser={activeUser}
            admin={admin}
            setShowMembers={setShowMembers}
            showMembers={showMembers}
            groupMembers={groupMembers}
            membersRef={membersRef}
            userRole={userRole}
            handleRemoveMember={handleRemoveMember}
            handleOpenAddMembers={handleOpenAddMembers}
            setNewGroupName={setNewGroupName}
            setShowEditGroup={setShowEditGroup}
            setShowExitGroupModal={setShowExitGroupModal}
            setShowDeleteGroupModal={setShowDeleteGroupModal}
            handleDeleteChatHistory={handleDeleteChatHistory}
          />

          {/* Chat container */}
          <ChatContainer
            messages={messages}
            activeUser={activeUser}
            admin={admin}
            editingMessageId={editingMessageId}
            editText={editText}
            setEditText={setEditText}
            saveEdit={saveEdit}
            setEditingMessageId={setEditingMessageId}
            DropdownActions={DropdownActions}
            handleDeleteMessage={handleDeleteMessage}
            messagesEndRef={messagesEndRef}
            setShowCreateGroup={setShowCreateGroup}
            className="flex-1 overflow-y-auto"
            onScroll={(e) => {
              const scrollTop = e.currentTarget.scrollTop;
              setShowFooter(scrollTop > 50);
            }}
          />

          <ChatInput
            handleSendMessage={handleSendMessage}
            isActiveUserConnected={isActiveUserConnected}
            activeUserId={activeUser?.id}
            sendFile={sendFile}
          />
        </>
      ) : (
        <div className="flex-1 flex items-center justify-center p-8">
           <div className="text-center max-w-[280px]">
    <div className="w-16 h-16 bg-[#e8f0f7] rounded-full flex items-center justify-center mx-auto mb-4">
      <MessageCircle size={24} className="text-[#0f6abf]" />
    </div>
    <h3 className="font-semibold text-gray-800 text-lg mb-2">
      Start a conversation
    </h3>
    <p className="text-gray-500 text-sm">
      Select a user or group from the sidebar to begin messaging
    </p>
  </div>
        </div>
      )}
    </div>
      </>
    )
  }
    
<CreateGroupModal showCreateGroup={showCreateGroup} newGroupName={newGroupName} setNewGroupName={setNewGroupName} newGroupImage={newGroupImage} setNewGroupImage={setNewGroupImage} handleCreateGroupSubmit={handleCreateGroupSubmit} loading={loading} setShowCreateGroup={setShowCreateGroup}/>
{showDeleteModal && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden">
      {/* Modal Header */}
      <div className="p-6 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Delete Chat</h3>
            <p className="text-sm text-gray-500 mt-0.5">This action cannot be undone</p>
          </div>
        </div>
      </div>

      {/* Modal Content */}
      <div className="p-6">
        <div className="text-center">
          <div className="mx-auto w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
          
          <h4 className="text-lg font-semibold text-gray-900 mb-2">
            Are you sure you want to delete this chat?
          </h4>
          <p className="text-gray-600">
            All messages in this conversation will be permanently deleted. This action cannot be undone.
          </p>
        </div>
      </div>

      {/* Modal Footer */}
      <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
        <div className="flex items-center justify-end gap-3">
          <button
            className="px-5 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
            onClick={() => setShowDeleteModal(false)}
            disabled={loadingDelete}
          >
            Cancel
          </button>
          <button
            className="px-5 py-2.5 bg-red-500 text-white font-medium rounded-xl hover:bg-red-600 transition-colors flex items-center gap-2 min-w-[100px] justify-center"
            onClick={confirmDeleteChatHistory}
            disabled={loadingDelete}
          >
            {loadingDelete ? (
              <ThreeDot color={["#ffffff"]} size="small" />
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                Delete Chat
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
 <AddMembersModal showAddMembers={showAddMembers} selectedGroup={selectedGroup} connectedUsers={connectedUsers} membersToAdd={membersToAdd} toggleMemberSelection={toggleMemberSelection} handleAddMembersSubmit={handleAddMembersSubmit} setShowAddMembers={setShowAddMembers}/>
  {showDeleteGroupModal && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden">
      {/* Modal Header */}
      <div className="p-6 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Delete Group</h3>
            <p className="text-sm text-gray-500 mt-0.5">This action cannot be undone</p>
          </div>
        </div>
      </div>

      {/* Modal Content */}
      <div className="p-6">
        <div className="text-center">
          <div className="mx-auto w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.998-.833-2.732 0L4.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          
          <h4 className="text-lg font-semibold text-gray-900 mb-2">
            Are you sure you want to delete this group?
          </h4>
          <p className="text-gray-600">
            This action is irreversible and will permanently delete the group, all messages, and remove all members.
          </p>
        </div>
      </div>

      {/* Modal Footer */}
      <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
        <div className="flex items-center justify-end gap-3">
          <button
            className="px-5 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
            onClick={() => setShowDeleteGroupModal(false)}
            disabled={loadingGroupDelete}
          >
            Cancel
          </button>
          <button
            className="px-5 py-2.5 bg-red-500 text-white font-medium rounded-xl hover:bg-red-600 transition-colors flex items-center gap-2 min-w-[100px] justify-center"
            onClick={confirmDeleteGroup}
            disabled={loadingGroupDelete}
          >
            {loadingGroupDelete ? (
              <ThreeDot color={["#ffffff"]} size="small" />
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                Delete Group
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
<EditGroupModal showEditGroup={showEditGroup} newGroupName={newGroupName} setNewGroupName={setNewGroupName} setNewGroupImage={setNewGroupImage} handleEditGroupSubmit={handleEditGroupSubmit} loading={loading} setShowEditGroup={setShowEditGroup}/>

 {showExitGroupModal && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden">
      {/* Modal Header */}
      <div className="p-6 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Exit Group</h3>
            <p className="text-sm text-gray-500 mt-0.5">This action cannot be undone</p>
          </div>
        </div>
      </div>

      {/* Modal Content */}
      <div className="p-6">
        <div className="text-center">
          <div className="mx-auto w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.998-.833-2.732 0L4.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          
          <h4 className="text-lg font-semibold text-gray-900 mb-2">
            Are you sure you want to exit this group?
          </h4>
          <p className="text-gray-600">
            You will no longer receive messages from this group and will be removed from the member list.
          </p>
        </div>
      </div>

      {/* Modal Footer */}
      <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
        <div className="flex items-center justify-end gap-3">
          <button
            className="px-5 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
            onClick={() => setShowExitGroupModal(false)}
          >
            Cancel
          </button>
          <button
            className="px-5 py-2.5 bg-red-500 text-white font-medium rounded-xl hover:bg-red-600 transition-colors flex items-center gap-2"
            onClick={() => {
              handleExitGroup();
              setShowExitGroupModal(false);
            }}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            Yes, Exit Group
          </button>
        </div>
      </div>
    </div>
  </div>
)}
  
  </main>

  {/* Footer */}
     {showFooter && (
    <div className="h-32 w-full">
      <Footer />
    </div>
  )}
</div>

  );
};

export default Chat;
